@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.main-content {
  z-index: 1;
  background: @grid-page--main-content--background-color;
  height: calc(100% - 140px);
}

.filter-content {
  padding: @space-8;
}

.grid-content {
  flex-grow: 1;
  display: flex;
  height: 100%;
  overflow-y: hidden;
}

.grid-and-footer {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: calc(100% ~'-' 446px);

  &.no-sidebar {
    max-width: 100%;
  }
}
